import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, FieldGroup } from "../../../design/fieldset";
import { Input } from "../../../design/input";
import { Heading, Subheading } from "../../../design/heading";
import { Textarea } from "../../../design/textarea";
import { useAccount } from "../../../contexts/AccountContext";
import { Button } from "../../../design/button";
import { AccountService } from "../../../services/AccountService";

interface Props {}

const SettingInformation: React.FC<Props> = () => {
  const { account } = useAccount();
  const config = (account?.configuration || {}) as Record<string, unknown>;

  const [defaultVisitationPrice, setDefaultVisitationPrice] = useState(
    (config?.defaultVisitationPrice as number) ?? 0,
  );
  const [defaultVisitNotes, setDefaultVisitNotes] = useState(
    (config?.defaultVisitNotes as string) ?? "",
  );
  const errors: Record<string, string> = {};
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const config = (account?.configuration || {}) as Record<string, unknown>;
    setDefaultVisitationPrice((config?.defaultVisitationPrice as number) ?? 0);
    setDefaultVisitNotes((config?.defaultVisitNotes as string) ?? "");
  }, [account]);

  const validateForm = () => {
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    if (!account?.id) return;

    setIsSaving(true);
    try {
      await AccountService.updateAccount(account.id, {
        configuration: {
          ...(account.configuration || {}),
          defaultVisitationPrice,
          defaultVisitNotes,
        },
      });
    } catch (e) {
      console.error("Error saving settings:", e);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Heading>Settings</Heading>
      <form onSubmit={handleSubmit}>
        <FieldGroup>
          <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
            <div className="space-y-1">
              <Subheading>Default Visitation Price</Subheading>
            </div>
            <div>
              <Field>
                <Input
                  id="defaultVisitationPrice"
                  name="defaultVisitationPrice"
                  placeholder="Default Visitation Price"
                  onChange={(e) =>
                    setDefaultVisitationPrice(parseFloat(e.target.value))
                  }
                  value={defaultVisitationPrice}
                  type="number"
                />
                {errors.defaultVisitationPrice && (
                  <ErrorMessage>{errors.defaultVisitationPrice}</ErrorMessage>
                )}
              </Field>
            </div>
          </section>
          <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
            <div className="space-y-1">
              <Subheading>Default Visit Notes</Subheading>
            </div>
            <div>
              <Field>
                <Textarea
                  id="defaultVisitNotes"
                  name="defaultVisitNotes"
                  placeholder="Default Visit Notes"
                  value={defaultVisitNotes}
                  onChange={(e) => setDefaultVisitNotes(e.target.value)}
                />
                {errors.defaultVisitNotes && (
                  <ErrorMessage>{errors.defaultVisitNotes}</ErrorMessage>
                )}
              </Field>
            </div>
          </section>
          <section>
            <div className="flex justify-end gap-4">
              <Button type="submit">
                {isSaving ? "Saving..." : "Save changes"}
              </Button>
            </div>
          </section>
        </FieldGroup>
      </form>
    </>
  );
};

export default SettingInformation;
